import { Link } from 'react-router-dom';
import { SITE_NAME, SITE_TAGLINE } from '@/lib/site';

interface WordmarkProps {
  /** `sm` pour le pied de page, où le logo est légèrement plus petit. */
  size?: 'md' | 'sm';
  to?: string;
}

export function Wordmark({ size = 'md', to }: WordmarkProps) {
  const content = (
    <span className={`nz-wordmark${size === 'sm' ? ' nz-wordmark--sm' : ''}`}>
      <span className="nz-wordmark__name">
        {SITE_NAME}
        <i className="nz-wordmark__dot" aria-hidden="true" />
      </span>
      <span className="nz-wordmark__tagline">{SITE_TAGLINE}</span>
    </span>
  );

  return to ? <Link to={to}>{content}</Link> : content;
}
